import type { RoundStatus } from '../types/competition-round';

/** How each state of a round is drawn, wherever one is named. */
export const STATUS_VARIANT: Record<RoundStatus, 'default' | 'secondary' | 'outline'> = {
  draft: 'outline',
  active: 'default',
  // Waiting on the people who score it: not running, not done with either.
  corrections: 'default',
  verification: 'default',
  closed: 'secondary',
};

/** The life of a round, in the order it is walked. Mirrors `Lifecycle::Round`. */
export const ROUND_STATUSES: RoundStatus[] = ['draft', 'active', 'corrections', 'verification', 'closed'];
